import { render } from "./LinkageLoginProfile.vue?vue&type=template&id=5bd54209&scoped=true&ts=true"
import script from "./LinkageLoginProfile.vue?vue&type=script&lang=ts"
export * from "./LinkageLoginProfile.vue?vue&type=script&lang=ts"

import "./LinkageLoginProfile.vue?vue&type=style&index=0&id=5bd54209&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd54209"]])

export default __exports__